"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllShields = void 0;
const shared_models_1 = require("@railgun-community/shared-models");
const engine_1 = require("./engine");
const getAllShields = async (networkName, startingBlock) => {
    const engine = (0, engine_1.getEngine)();
    const { chain } = shared_models_1.NETWORK_CONFIG[networkName];
    const shieldCommitments = await engine.getAllShieldCommitments(chain, startingBlock);
    return shieldCommitments.map(commitment => {
        const shieldData = {
            txid: `0x${commitment.txid}`,
            commitmentHash: `0x${commitment.hash}`,
            npk: commitment.preImage.npk,
            utxoTree: commitment.utxoTree,
            utxoIndex: commitment.utxoIndex,
            timestamp: commitment.timestamp,
            blockNumber: commitment.blockNumber,
        };
        return shieldData;
    });
};
exports.getAllShields = getAllShields;
